import VoteButtons from './VoteButtons';

export default VoteButtons;
